import React from 'react'
import ScreenLoader from '../../ui/ScreenLoader/ScreenLoader.component'

type LoadingIndicatorProps = {
  isLoading: boolean
  container?: HTMLElement
  height?: number
  style?: React.CSSProperties
}

/**
 * Legacy module loading overlay.
 * Prefer `ScreenLoader` from `@components/ui` for new DS usage.
 */
const LoadingIndicator = React.memo(
  ({ isLoading, container, height = 6, style }: LoadingIndicatorProps) => (
    <ScreenLoader
      open={isLoading}
      container={container}
      height={height}
      style={style}
    />
  ),
)

LoadingIndicator.displayName = 'LoadingIndicator'
export default LoadingIndicator
